import axios from "axios";
import React, { useEffect, useState } from "react";
import { hostname } from "src/HostName";

const useGetB2BAgentsData = (userId) => {
  const [stateObjData, setStateObjData] = useState({
    loading: true,
    getAgents: [],
    error: "",
  });
  const { loading, getAgents, error } = stateObjData;
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${hostname}get/b2bAgents`, {
          userid: userId,
        });
        setStateObjData((pre) => ({
          ...pre,
          getAgents: data.agents || [],
        }));
      } catch (error) {
        setStateObjData((pre) => ({
          ...pre,
          error: "error",
        }));
      }
      setStateObjData((pre) => ({
        ...pre,
        loading: false,
      }));
    })();
  }, []);
  return [loading, getAgents, error];
};

export default useGetB2BAgentsData;
